// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty.js';
import BadgeText from './styles/ZoneSixBadges.style';

const ZoneSixBadges = (props) => {
  const { className, text, isFinalSaleProduct } = props;
  if (isFinalSaleProduct) {
    return (
      <BodyCopy
        fontFamily="secondary"
        fontSize={['fs10', 'fs10', 'fs12']}
        fontWeight="semibold"
        className={`${className} zone-six-final-sale-label`}
        color={'red.500'}
      >
        {getDynamicLabelValues('dynamic.browse_d.lbl_final_sale')}
      </BodyCopy>
    );
  }
  return (
    <BadgeText
      fontFamily="secondary"
      fontSize={['fs10', 'fs10', 'fs12']}
      className={`${className} zone-six-label`}
    >
      {text?.toLowerCase()}
    </BadgeText>
  );
};

ZoneSixBadges.defaultProps = {
  className: '',
  isFinalSaleProduct: false,
};

ZoneSixBadges.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  isFinalSaleProduct: PropTypes.bool,
};

export default ZoneSixBadges;
